import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import EventActionHeader from '../../components/EventActionHeader';
import NoEvents from '../../components/NoEvents';
import RegisterEvent from '../../components/RegisterEvents';
import { useStyles } from '../../styles';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { getregisteredevents } from '../../utils/services';
import { getEventsData, getRegisterEvents } from '../../../../Utils/apiService';
import { AllEvents, AppFilterFields } from '../../utils/interfaces';
import { AppFilterFunction } from '../../utils/helpers';
import KenLoader from '../../globalComponent/KenLoader';
import AppFilter from '../../globalComponent/AppFilter';
import { filterDependencyArray } from '../../utils/eventFilterForm';
import { AppButton } from '../../globalComponent/AppButton';
import KenColors from '../../utils/kenColors';
import routes from '../../../../Utils/routes';
import BannerCard from '../../globalComponent/BannerCard';
import Image from '../../../../Assets/application_notFound.png';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';

export const createRecord = (items: any) => {
  return {
    ...items,
    Id: items?.Id,
    name: items?.eventTitle,
    title: items?.eventTitle,
    startTime: items?.startDate,
    endTime: items?.endDate,
    mode: 'Hybrid',
    fee: null,
    location: null,
    eventLength: 'One day',
    noOfParticipant: items?.maximumNumberofParticipants,
    description: items?.description,
    secondaryDescription: items?.agenda,
    deliveryLanguage: items?.languageOfDelivery,
    coverImage: items?.coverImage?.imageUrl,
    suitableFor: 'Faculty',
    duration: items?.duration,
  };
};

const DashBoard: React.FunctionComponent = () => {
  const classes = useStyles();
  const navigate = useHistory();
  const { state: { user } } = useContext(AuthContext);
  const userData = user as any;
  const [loading, setLoading] = useState<boolean>(false);
  const [filter, setFilter] = useState<boolean>(false);
  const [registeredEventsStatus, setRegisteredEventsStatus] = useState<'Upcoming' | 'Past events'>('Past events');
  const [filterData, setFilterData] = useState<AppFilterFields>({});
  const [eventStatus, setEventStatus] = useState(false);
  const [eventsData, setEventsData] = useState<AllEvents>({
    events: { featured: [], upcoming: [] },
    registedredEvents: [],
    filteredEvents: { featured: [], upcoming: [] },
    postedEvent: [],
    pastEvents: [],
  });
  console.log(eventsData.filteredEvents.featured, "121232123eecfd");
  const ismobile = window.innerWidth <= 600;
  const [eventsDatas, setEventsDatas] = useState<AllEvents>({
    events: { featured: [], upcoming: [] },
    registedredEvents: [],
    filteredEvents: { featured: [], upcoming: [] },
    postedEvent: [],
    pastEvents: [],
  });


  const handleRegisteredEvents: (key: 'Upcoming' | 'Past events') => void = (key: 'Upcoming' | 'Past events') => {
    setRegisteredEventsStatus(key);
  };

  const handleFilterOpen = () => {
    setFilter(!filter);
  };

  const handleFilterCancellation = () => {
    // setEventsData({ ...eventsData, filteredEvents: { featured: eventsData.events.featured, upcoming: eventsData.events.upcoming } });
    // setFilterData({});
    handleFilterOpen();
  };

  const handleFilterCells = (data: string, key: string) => {
    setFilterData({ ...filterData, [key]: data });
  };

  const handleFiltering: SubmitHandler<AppFilterFields> = (data) => {
    handleFilterOpen();
  };

  const handleFilerRemove: (key: string) => void = (key: string) => {
    const sampleFilters = { ...filterData };
    delete sampleFilters[key];
    setFilterData(sampleFilters);
  };
  const [createdByMeEvent, setcreatedByMeEvents] = useState<any>([]);
  useEffect(() => {
    setLoading(true);
    getRegisterEvents(userData?.applicantId).then((res:any) => {
      if (res?.data && typeof res.data === 'string') {
        try {
          const data = JSON.parse(res.data);
          const createdByMeEvents = data?.filter((item: any) => item.createdbyMe === true);
          setcreatedByMeEvents(createdByMeEvents);
        } catch (error) {
          console.error('Error parsing register events data:', error);
          setcreatedByMeEvents([]);
        }
      } else {
        setcreatedByMeEvents([]);
      }
    }).catch((error) => {
      console.error('Error fetching register events:', error);
      setcreatedByMeEvents([]);
    });
    
    getEventsData()
      .then(async (res) => {
        if (res?.result && typeof res.result === 'string') {
          try {
            const datasss = JSON.parse(res.result);
            console.log('datasss', datasss);

            const data = JSON.parse(res?.result).map((items: any) => {
              items['duration'] = items?.endDate && items.startDate ? moment(items?.endDate).diff(items.startDate, 'days') : 0;
              return items;
            });

            const upcomingEvents = data
              ?.filter((items: any) => {
                return items?.isUpcoming === true && items?.isApproved === true;
              })
              .map((items: any) => {
                return createRecord(items);
              });

            const featuredEvents = data
              ?.filter((items: any) => {
                return items?.isUpcoming === false && items?.ispast === false;
              })
              .map((items: any) => {
                return createRecord(items);
              });

            const pastEvents = data
              ?.filter((items: any) => {
                return items?.ispast === true;
              })
              .map((items: any) => {
                return createRecord(items);
              });
            // console.log('res45654', pastEvents, upcomingEvents);
            setEventsData({
              events: { featured: featuredEvents, upcoming: upcomingEvents },
              filteredEvents: { featured: featuredEvents, upcoming: upcomingEvents },
              registedredEvents: upcomingEvents,
              postedEvent: [],
              pastEvents: pastEvents,
            });
            setLoading(false);
          } catch (error) {
            console.error('Error parsing events data:', error);
            setEventsData({
              events: { featured: [], upcoming: [] },
              filteredEvents: { featured: [], upcoming: [] },
              registedredEvents: [],
              postedEvent: [],
              pastEvents: [],
            });
            setLoading(false);
          }
        } else {
          setEventsData({
            events: { featured: [], upcoming: [] },
            filteredEvents: { featured: [], upcoming: [] },
            registedredEvents: [],
            postedEvent: [],
            pastEvents: [],
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    getregisteredevents(userData?.applicantId)
      .then(async (res: { result: any; }) => {
        const data = (res?.result?.data).map((items: any) => {
          items['duration'] = items?.endDate && items.startDate ? moment(items?.endDate).diff(items.startDate, 'days') : 0;
          return items;
        });
        console.log(data, "datadatadatadatadata");

        const upcomingEvents = data
          ?.filter((items: any) => {
            return items?.isUpcoming === true;
          })
          .map((items: any) => {
            return createRecord(items);
          });

        const featuredEvents = data
          ?.filter((items: any) => {
            return items?.isUpcoming === false && items?.ispast === false;
          })
          .map((items: any) => {
            return createRecord(items);
          });

        const pastEvents = data
          ?.filter((items: any) => {
            return items?.ispast === true;
          })
          .map((items: any) => {
            return createRecord(items);
          });
        // console.log('res45654', pastEvents, upcomingEvents);
        setEventsDatas({
          events: { featured: featuredEvents, upcoming: upcomingEvents },
          filteredEvents: { featured: featuredEvents, upcoming: upcomingEvents },
          registedredEvents: upcomingEvents,
          postedEvent: [],
          pastEvents: pastEvents,
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  useEffect(() => {
    const data = AppFilterFunction({ data: [...eventsData.events.featured, ...eventsData.events.upcoming], filterData: filterData });
    const featured: Array<any> = [];
    const upcoming: Array<any> = [];
    data?.forEach((items: any) => {
      if (items?.isUpcoming === false && items?.ispast === false) {
        featured.push({ ...items });
      } else {
        upcoming.push({ ...items });
      }
    });
    setEventsData({ ...eventsData, filteredEvents: { featured: [...featured], upcoming: [...upcoming] } });
  }, [filterData]);
  console.log('window56', window.innerWidth);

  // Add this function to clear all filters
  const handleClearAllFilters = () => {
    setFilterData({});
  };

  return (
    <>
      {loading && (eventsData.events.featured?.length === 0 || eventsData.events.upcoming?.length === 0) ? (
        <KenLoader />
      ) : (
        <Grid
          item
          container
          spacing={2}
          xs={12}
          lg={12}
          sx={{
            background:'transparent',
            height: '90vh',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '85vh',
            },
            '@media (min-width: 280px) and (max-width: 600px)': {
              height: '80vh',
            },
          }}
          className="scrollbar-cusgrayHeader"
        >
          {/* {ismobile && (
            <Grid item xs={12} sm={6} md={12} lg={12} sx={{
              marginTop: '-38px',
              '@media (min-width: 1240px) and (max-width: 1280px)': {
                marginTop: '-28px',
              },
              '@media (min-width: 300px) and (max-width: 620px)': {
                marginTop: '0px',
              },

            }}>
              <BannerCard inProgressThings={eventsData.postedEvent} image="data:image/svg+" createdByMeEvents={createdByMeEvent} progresstitle="Your Event Request" title={'Host an Event'} />
            </Grid>
          )} */}
          <Grid item xs={12} md={7} lg={9} xl={9}>
            {eventsData.filteredEvents.upcoming?.length === 0 ? (
              <NoEvents
                filterData={filterData}
                handleFilerRemove={(key) => {
                  handleFilerRemove(key);
                }}
                handleFilterOpen={() => {
                  handleFilterOpen();
                }}
              />
            ) : (
              <Paper
                className={`scrollbar-cusgray ${classes.cardContainer}`}
                sx={{
                  background:'transparent',
                  height: {
                    xs: 'auto !important',
                    sm: '82.5vh !important',
                  },
                }}
              >
                <Box className="w-100 d-flex flex-column" gap={'20px'}>
                  {eventsData.filteredEvents.upcoming?.length > 0 && (
                    <EventActionHeader
                      eventsData={eventsData.filteredEvents.upcoming}
                      filterData={filterData}
                      title="Upcoming Events"
                      handleFilerRemove={(key: any) => {
                        handleFilerRemove(key);
                      }}
                      handleFilterOpen={handleFilterOpen}
                      filterButtonDisable={eventsData.filteredEvents.upcoming?.length > 0}
                    />
                  )}
                </Box>
                {!ismobile && (<Button
                  style={{ textTransform: 'capitalize' }}
                  size="small"
                  onClick={() => {
                    handleFilterOpen();
                  }}
                  variant="contained"
                  startIcon={
                    <FilterAltOutlinedIcon
                      sx={{
                        fontSize: { xs: '20px', sm: '22px', md: '26px', lg: '28px' },
                        color: KenColors.ClientBlack2,
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '15px',
                        },
                      }}
                    />
                  }
                  className={classes.filterBtn}
                >
                  Filters
                </Button>)}
              </Paper>
            )}
            <AppFilter
              transform={{ top: '-84%', left: '32%' }}
              filterData={filterData}
              dependencyArray={filterDependencyArray([...(eventsData.events.featured ? eventsData.events.featured : []), ...(eventsData.events.upcoming ? eventsData.events.upcoming : [])])}
              handleChange={handleFilterCells}
              handleClose={handleFilterCancellation}
              handleFilterSubmit={handleFiltering}
              open={filter}
              handleClearAll={handleClearAllFilters}
            />
          </Grid>
          <Grid item container spacing={2} xs={12} md={5} lg={3} xl={3}>
            <Grid item lg={12} md={12} sm={6} xs={12}>
              <Paper
                className="scrollbar-cusgray"
                sx={{
                  margin:'15px 15px 10px 0px',
                  height: '88vh !important',
                  '@media (min-width: 1240px) and (max-width: 1280px)': {
                    height: '80vh !important',
                  },
                  boxShadow: 'none',
                  borderRadius: '9px',
                  display: 'flex', // Use Flexbox
                  flexDirection: 'column', // Arrange children vertically
                  '@media (min-width: 1290px) and (max-width: 1300px)': {
                    height: '80vh !important',
                  },
                }}
              >
                <Box padding={'22px 22px 12px 22px'}>
                  <Typography className={classes.registeredEventsHeading} pb={ismobile ? 2 : 0}>Registered events</Typography>
                  <Box className={classes.eventsCardBox}>
                    <Grid container>
                      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <AppButton
                          size="small"
                          variant="contained"
                          className={classes.postJobBtns}
                          others={{ color: eventStatus ? "white" : '#8C8E94' }}
                          background={eventStatus ? '' : '#F6F8FB'}
                          onClick={() => {
                            setEventStatus(true);
                            setRegisteredEventsStatus('Upcoming');
                          }}
                        >
                          Upcoming
                        </AppButton>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <AppButton
                          size="small"
                          variant="contained"
                          className={classes.postJobBtns}
                          others={{ color: eventStatus ? '#8C8E94' : "white" }}
                          background={eventStatus ? '#F6F8FB' : ''}
                          onClick={() => {
                            setEventStatus(false);
                            setRegisteredEventsStatus('Past events');
                          }}
                        >
                          Past events
                        </AppButton>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                  <Paper className={`${classes.registerEventsContainer} scrollbar-cusgray`}>
                    {loading ? (
                      <KenLoader /> // Show the loader while fetching data
                    ) : registeredEventsStatus === 'Past events' ? (
                      eventsDatas?.pastEvents?.length > 0 ? (
                        eventsDatas.pastEvents.map((items: any, index: number) => (
                          <RegisterEvent key={index} data={items} />
                        ))
                      ) : (
                        <Paper className={classes.noEvent}>
                          <img className={classes.noEventImage} src={Image} alt="noupcoming" />
                          <Typography color={KenColors.ClientBlack2} fontWeight={'400'} fontSize={'12px'}>
                            No past events available.
                          </Typography>
                        </Paper>
                      )
                    ) : eventsDatas?.registedredEvents?.length > 0 ? (
                      eventsDatas.registedredEvents.map((items: any, index: number) => (
                        <RegisterEvent key={index} data={items} />
                      ))
                    ) : (
                      <Paper className={classes.noEvent}>
                        <img className={classes.noEventImage} src={Image} alt="noupcoming" />
                        <Typography color={KenColors.ClientBlack2} fontWeight={'400'} fontSize={'12px'}>
                          No upcoming registered events.
                        </Typography>
                      </Paper>
                    )}
                  </Paper>
                </Box>
                <Box component={'div'} padding={'10px'} paddingTop={'30px'} sx={{ marginTop: 'auto' }}>
                  <AppButton
                    fullWidth
                    size="medium"
                    variant="outlined"
                    others={{
                      color: "white",
                      border: 'none',
                      fontSize: '12px !important',
                      height: '30px',
                      backgroundColor: "#4B3776",
                    }}
                    border="none"
                    background={KenColors.ClientBlue}
                    onClick={() => {
                      navigate.push(`${routes.registeredEvents}?tab=upcoming`);
                    }}
                  >
                    View more
                  </AppButton>
                </Box>
              </Paper>
            </Grid>
            {/* {!ismobile && (
              <Grid item xs={12} sm={6} md={12} lg={12} sx={{
                marginTop: '-38px',
                '@media (min-width: 1240px) and (max-width: 1280px)': {
                  marginTop: '-28px',
                },
                '@media (min-width: 300px) and (max-width: 620px)': {
                  marginTop: '8px',
                },

              }}>
                <BannerCard inProgressThings={eventsData.postedEvent} image="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTk5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5Ib3N0IEV2ZW50PC90ZXh0Pgo8L3N2Zz4K" createdByMeEvents={createdByMeEvent} progresstitle="Your Event Request" title={'Host an Event'} />
              </Grid>
            )} */}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default DashBoard;